import AdvertH from "../../images/AdvertH.webp"

const AdvertHero = () => {
  return (
    <div className="flex flex-col items-center gap-8 sm:gap-12 xl:gap-16 w-full xl:h-[816px] bg-[#101928] overflow-hidden px-4 sm:px-8 xl:px-0 py-12 sm:py-16 xl:py-0">
      {/* Frame 2147228667 */}
      <div className="flex flex-col items-center gap-6 xl:gap-8 w-full xl:w-[1019px] xl:h-[172px]">
        {/* Frame 2147228666 */}
        <div className="flex flex-col items-center gap-4 w-full xl:w-[1019px] xl:h-[172px]">
          {/* Heading */}
          <h1 className="font-medium leading-[100%] text-[28px] sm:text-[36px] xl:text-[48px] xl:h-[114px] xl:pt-24 text-center text-white">
            Tap into the core of the <span className="text-[#0D924F]">Sustainability<bri/> Economy.</span>
          </h1>

          {/* Subtitle */}
          <p className="max-w-[841px] w-full xl:h-[42px] xl:pt-20 font-normal text-[15px] sm:text-[16px] xl:text-[18px] text-center text-[#B1B1B1]">
            CloseCarbon offers high-visibility advertisement slots and sponsored content opportunities for brands looking to engage with verified corporate offsetters.
          </p>
        </div>
      </div>

      {/* Image */}
      <img src={AdvertH} className="w-full xl:w-auto xl:pt-[120px] object-cover rounded-t-xl" alt="Advert" />
    </div>
  );
};

export default AdvertHero